import React from "react";
import { Link } from "react-router-dom";
import HeaderMenuItem from "../HeaderMenuItem";
import { ourServicesMenuItems, aboutUsMenuItemsCustomer, loggedInCustomerSupportMenuItems, accountMenuItems } from "../constants";
import { buildMenuItemsForDisposal } from "../helpers";
import avatarIcon from "../../../assets/icons/avatar.svg";
import { PowerSettingsNewOutlined } from "@material-ui/icons";
import history from "../../../history";
import { Button } from "@material-ui/core";
import classes from "@css/components/website/Header.module.css";
import { usePrivileges } from "../../../shared/hooks/useSessionPrivileges";

interface CustomerLoggedInProps {
  isOpaque: boolean;
  isDisposalPage: boolean;
  pathname: string;
  posts: any[];
  signOut: () => void;
}

function CustomerLoggedIn({ isOpaque, isDisposalPage, pathname, posts, signOut }: CustomerLoggedInProps) {
  const { hasPrivilege } = usePrivileges();
  const caseStudyItems = buildMenuItemsForDisposal(pathname, posts);
  const primaryButtonClasses = isOpaque ? classes.primaryButton : classes.primaryButtonDark;
  const showSustainability = hasPrivilege("SHOW_SUSTAINABILITY_DASHBOARD");

  const signOutMenuItem = {
    label: "Sign Out",
    icon: <PowerSettingsNewOutlined color="primary" />,
    func: signOut,
  };

  const sideLinks = accountMenuItems({ showSustainability }, false).customerSideNavLinks.filter((link) => !link.hidden);

  return (
    <>
      {/* Menu Items */}
      <div className={classes.menuContainer}>
        <HeaderMenuItem isOpaque={isOpaque} name="Our Services" menuItems={ourServicesMenuItems} extended={true} />

        {Boolean(isDisposalPage && caseStudyItems.length) && <HeaderMenuItem isOpaque={isOpaque} name="Case Studies" menuItems={caseStudyItems} />}

        {Boolean(isDisposalPage && !caseStudyItems.length) && (
          <Button
            disableRipple
            className={classes.menuButton}
            style={{ color: isOpaque ? "black" : "white" }}
            onClick={() => history.push("/case-studies")}
          >
            Case Studies
          </Button>
        )}

        <HeaderMenuItem isOpaque={isOpaque} name="My Bookings" linkTo="/bookings" />
        {showSustainability && <HeaderMenuItem isOpaque={isOpaque} name="Sustainability Dashboard" linkTo="/dashboard" chipText="New!" />}
        <HeaderMenuItem isOpaque={isOpaque} name="About" menuItems={aboutUsMenuItemsCustomer} />
        <HeaderMenuItem isOpaque={isOpaque} name="Support" menuItems={loggedInCustomerSupportMenuItems} />
      </div>

      {/* Action Buttons */}
      <div className={classes.buttonContainer}>
        <div className={classes.buttonContainerInner}>
          <div className={classes.customerButtonContainer}>
            <Link to="booking?step=initial" className={primaryButtonClasses}>
              Book Now
            </Link>

            <HeaderMenuItem isOpaque={isOpaque} icon={avatarIcon} name="" menuItems={[...sideLinks, signOutMenuItem]} />
          </div>
        </div>
      </div>
    </>
  );
}

export default CustomerLoggedIn;
